import { alertDialogPreset } from './alert/alert.dialog.preset';
import { confirmDialogPreset } from './confirm/confirm.dialog.preset';
import { miniModalDialogPreset } from './mini-modal/mini-modal.dialog.preset';

export function configureMdDialogProvider($mdDialogProvider) {
    'ngInject';

    $mdDialogProvider.addPreset(alertDialogPreset.name, alertDialogPreset);
    $mdDialogProvider.addPreset(confirmDialogPreset.name, confirmDialogPreset);
    $mdDialogProvider.addPreset(miniModalDialogPreset.name, miniModalDialogPreset);
}



// WEBPACK FOOTER //
// ./src/lib/components/dialog/md-dialog-provider.config.ts